import { React, lazy, Suspense, useEffect, useContext } from 'react';
import { ThemeContext } from './context/ThemeContext';
import { Toaster } from 'react-hot-toast';

import { useSelector, useDispatch } from 'react-redux'
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from 'react-router-dom'


import LoginPhone from './pages/auth/LoginPhone';
import RegisterEmail from './pages/auth/RegisterEmail';
import LoginEmail from './pages/auth/LoginEmail';
import VerifyEmail from './pages/auth/VerifyEmail';

//ROUTES
import Dashboard from './pages/dashboard/Dashboard';
import EventList from './pages/event/EventList';
import EventDetail from './pages/event/EventDetail';
import MeetingList from './pages/meeting/MeetingList';
import MeetingFutureList from './pages/meeting/MeetingFutureList';
import MeetingPastList from './pages/meeting/MeetingPastList';
import MeetingDetail from './pages/meeting/MeetingDetail';
import EventDetailVideo from './pages/event/EventDetailVideo';
import Profile from './pages/profile/Profile';
import MyProfile from './pages/profile/MyProfile';
import SimpleMeetingAdd from './pages/meeting/SimpleMeetingAdd';
import Store from './pages/store/Store';
import Notificationplace from './pages/notification/Notificationplace';

import Calendar from './pages/calendar/Calendar';
import BookingSettings from './pages/booking/BookingSettings';
import PublicBooking from './pages/booking/PublicBooking';

import About from './pages/about/About';








/// Layout
import Nav from "./jsx/layouts/nav";
import Footer from "./jsx/layouts/Footer";
import ScrollToTop from "./jsx/layouts/ScrollToTop";

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";

function App() {

  const navigate = useNavigate();
  const { menuToggle } = useContext(ThemeContext);

  const isAuthenticated = useSelector((state) => state.auth.user !== null);


  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);



  useEffect(() => {

    if (!isAuthenticated) {
      //navigate('/login')
    }

  }, [isAuthenticated, navigate])



  if (isAuthenticated) {
    return (
      <>
        <Suspense fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
        >
          <div
            id={"main-wrapper"}
            className={`show${menuToggle ? " menu-toggle" : ""}`}
          >
            <Nav />
            <div className={"content-body"} style={{ paddingTop: '4.5rem' }}>
              <div style={{ padding: '12px 24px 12px' }}>
                <button
                  onClick={() => navigate(-1)}
                  style={{
                    background: '#f0f0f5',
                    border: 'none',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: '#444',
                    fontSize: '0.82rem',
                    fontWeight: 500,
                    padding: '6px 14px',
                  }}
                >
                  <i className="fa fa-arrow-left" style={{ fontSize: '11px' }} aria-hidden="true"></i>
                  Geri
                </button>
              </div>
              <div
                className={"container-fluid"}
                style={{ minHeight: window.screen.height - 60 }}
              >
                <Routes>
                  <Route path="/" element={<MeetingFutureList />} />
                  <Route path="/dashboard" element={<MeetingFutureList />} />


                  <Route path="/allmeetings" element={<MeetingPastList />} />
                  <Route path="/past" element={<Navigate to="/allmeetings" replace />} />


                  <Route path="/Discover" element={<EventList />} />
                  <Route path="/EventList" element={<EventList />} />
                  <Route path="/EventDetail/:eventId" element={<EventDetail />} />
                  <Route path="/EventDetailVideo/:eventId" element={<EventDetail />} />


                  <Route path="/MeetingList" element={<MeetingList />} />
                  <Route path="/meeting/:meetingId" element={<MeetingDetail />} />
                  <Route path="/MeetingDetail/:meetingId" element={<MeetingDetail />} />
                  <Route path="/MeetingAdd" element={<SimpleMeetingAdd />} />
                  
                  <Route path="/Profile/:profileId" element={<Profile />} />
                  <Route path="/user/:profileId" element={<Profile />} />
                  <Route path="/MyProfile" element={<MyProfile />} />
                  <Route path="/:page" element={<Dashboard />} />
                  
                  <Route path="/notification" element={<Notificationplace />} />


                  <Route path="/Store" element={<Store />} />
                  
                  <Route path="/calendar" element={<Calendar />} />
                  <Route path="/booking-settings" element={<BookingSettings />} />
                  <Route path="/u/:userId" element={<PublicBooking />} />
                    <Route path="/about" element={<About />} />


                </Routes>
              </div>
            </div >
            <Footer />
          </div >
          <ScrollToTop />
        </Suspense>
        <Toaster position="top-right" />
      </>
    );
  } else {
    return (
      <>
        <Routes>

          <Route path="/login" element={<LoginPhone />} />
          <Route path="/loginphone" element={<LoginPhone />} />
          <Route path="/loginemail" element={<LoginEmail />} />
          <Route path="/register" element={<RegisterEmail />} />
          <Route path="/verifyemail" element={<VerifyEmail />} />
          <Route path="/" element={<LoginPhone />} />
          <Route path="/u/:userId" element={<PublicBooking />} />
          
        </Routes>
        <Toaster position="top-right" />
      </>
    );
  }



}

export default App;
